import { JSONLD, Generic } from 'react-structured-data';

export default function StructuredDataJson({ type, productData, title, description, code, image }) {
  return (
    <JSONLD>
      <Generic
        type={type}
        jsonldtype={type}
        schema={{
          name: title,
          description: description,
          headline: title,
          image: image,
          sku: code,
          priceCurrency: productData?.default_variation?.currency,
          price: productData?.default_variation?.price,
        }}
      >
        <Generic type="author" jsonldtype="Person" schema={{ name: 'Anna Maria Mazaraki' }} />
        <Generic type="publisher" jsonldtype="Organization" schema={{ name: 'Anna Maria Mazaraki' }} />
        {/* <Generic type="datePublished" jsonldtype="Date" schema={{ name: dateFormat }} /> */}
      </Generic>
    </JSONLD>
  );
}
